import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserPassportForm } from "Bands/components";
import { createUserPassport, dispatchGetUserPassports } from "Bands/state";
import { IUserPassportPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { IdCard } from "shared/assets/icons";

const { userPassport: passportCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserPassportModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: passportCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserPassportPatchData) => {
    dispatch(createUserPassport(data));
  };

  const handleSuccess = () => {
    dispatchGetUserPassports(dispatch);
  };

  return (
    <UserEntityModal
      title={passportCopy.create.title}
      icon={IdCard}
      action={USER_ACTIONS.createUserPassport}
      buttons={buttons}
      successMessage={passportCopy.messages.created}
      Component={UserPassportForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
